import React from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

import yup from '../../utility/yup';
import FormInput from '../../components/form-input/FormInput';

export const videosSchema = {
  videos: yup.string().required().trim(),
};

const useStyle = makeStyles(() => createStyles({
  textArea: {
    height: '50vh !important',
    fontFamily: 'monospace',
    overflow: 'auto !important',
  },
}), { name: 'VideoMenus' });

const TabVideos = () => {
  const classes = useStyle();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <FormInput
          label="Videos"
          name="videos"
          type="textarea"
          classes={{ input: classes.textArea }}
        />
      </Grid>
    </Grid>
  );
};


export default TabVideos;
